import * as React from "react";
import { motion } from "framer-motion";
import { Tooltip } from "@mantine/core";

import stampData from "./stamps.json";

interface SampleGridProps {
  onSelect: (id: string) => void;
  selectedId: string | null;
  filteredKeys: string[];
  isMobile?: boolean;
}

export function SampleGrid({ onSelect, selectedId, filteredKeys, isMobile }: SampleGridProps) {
  return (
    <div className="stamp-grid-scroll" style={{ padding: "1rem 1.5rem", height: "100%", overflowY: "auto" }}>
      <div
        className="stamp-grid"
        style={{
          columns: isMobile ? "auto 100px" : "auto 180px",
          columnGap: isMobile ? "6px" : "10px",
        }}
      >
        {filteredKeys.map((key) => (
          <StampCard
            key={key}
            stampKey={key}
            isSelected={selectedId === key}
            hasSelection={!!selectedId}
            onSelect={onSelect}
            isMobile={isMobile}
          />
        ))}
      </div>
    </div>
  );
}

interface StampCardProps {
  stampKey: string;
  isSelected: boolean;
  hasSelection: boolean;
  onSelect: (id: string) => void;
  isMobile?: boolean;
}

const StampCard = React.memo(function StampCard({
  stampKey,
  isSelected,
  hasSelection,
  onSelect,
  isMobile,
}: StampCardProps) {
  const [loaded, setLoaded] = React.useState(false);
  const imgSrc = `https://vidyagiri.com/stamps/img/${stampKey}.png`;
  const data = (stampData as Record<string, any>)[stampKey];
  const label = `[${stampKey}] ${data?.country ?? ""}`;

  const card = (
    <div
      onClick={() => onSelect(stampKey)}
      style={{
        cursor: "pointer",
        breakInside: "avoid",
        marginBottom: isMobile ? "6px" : "10px",
        display: "inline-block",
        width: "100%",
      }}
    >
      <motion.img
        src={imgSrc}
        alt={`stamp ${stampKey}`}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        initial={{ opacity: 0 }}
        animate={{
          opacity: loaded ? (isSelected ? 1 : hasSelection ? 0.35 : 1) : 0,
          filter: isSelected
            ? "drop-shadow(0 6px 18px rgba(0,0,0,0.4))"
            : "drop-shadow(0 0px 0px rgba(0,0,0,0))",
        }}
        transition={{ duration: 0.35, ease: [0.215, 0.61, 0.355, 1] }}
        whileHover={{ opacity: 1, filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.25))" }}
        style={{ width: "100%", display: "block" }}
      />
    </div>
  );

  if (isMobile) return card;

  return (
    <Tooltip.Floating label={label} fz="xs" ff="IM Fell English, serif">
      {card}
    </Tooltip.Floating>
  );
});
